import { useEffect } from "react";
import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";

export default function DurataStep({ data, errors, update }) {
  useEffect(() => {
    const durata = Number(data.durata);
    let preavizRecomandat;
    if (durata <= 6) preavizRecomandat = "15";
    else if (durata <= 12) preavizRecomandat = "30";
    else preavizRecomandat = "60";

    if (data.notificareZile !== preavizRecomandat) {
      update("notificareZile")(preavizRecomandat);
    }
  }, [data.durata]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <InputField label="Data inceput contract" value={data.dataInceput} onChange={update("dataInceput")} type="date" required half error={errors.dataInceput} />
      <SelectField
        label="Durata contractului"
        value={data.durata}
        onChange={update("durata")}
        options={[
          { value: "6", label: "6 luni" },
          { value: "12", label: "12 luni (1 an)" },
          { value: "24", label: "24 luni (2 ani)" },
          { value: "36", label: "36 luni (3 ani)" },
        ]}
        half
      />
      <p style={{ width: "100%", fontSize: "11px", color: "#8a7e70", margin: "-8px 0 0 0" }}>
        Contractul este incheiat pe durata determinata.
      </p>
      <SelectField
        label="Preaviz reziliere (zile)"
        value={data.notificareZile}
        onChange={update("notificareZile")}
        options={[
          { value: "15", label: "15 zile" },
          { value: "30", label: "30 zile" },
          { value: "60", label: "60 zile" },
          { value: "90", label: "90 zile" },
        ]}
        half
      />
    </div>
  );
}
